var _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2344 24.0625C53.9375 29.2969 58 37.8906 58 42.0312C58 51.9531 50.1094 60 40.5 60C30.8125 60 23 51.9531 23 42.0312C23 36.4062 28.3906 27.1875 36.125 20C39.0938 22.8125 41.75 25.7812 43.8594 28.75C45.1875 27.1094 46.5938 25.5469 48.2344 24.0625ZM46.75 50.625C50.5781 47.9688 51.4375 42.7344 49.3281 38.6719C49.0938 38.2031 48.7812 37.6562 48.4688 37.1094L43.8594 42.3438C43.8594 42.3438 36.6719 33.125 36.125 32.5C32.375 37.1094 30.5 39.7656 30.5 42.7344C30.5 48.8281 35.0312 52.5 40.6562 52.5C42.9219 52.5 45.0312 51.7969 46.75 50.625Z",
    fill: "#F79009"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_23641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 20,
    width: 35,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2344 24.0625C53.9375 29.2969 58 37.8906 58 42.0312C58 51.9531 50.1094 60 40.5 60C30.8125 60 23 51.9531 23 42.0312C23 36.4062 28.3906 27.1875 36.125 20C39.0938 22.8125 41.75 25.7812 43.8594 28.75C45.1875 27.1094 46.5938 25.5469 48.2344 24.0625ZM46.75 50.625C50.5781 47.9688 51.4375 42.7344 49.3281 38.6719C49.0938 38.2031 48.7812 37.6562 48.4688 37.1094L43.8594 42.3438C43.8594 42.3438 36.6719 33.125 36.125 32.5C32.375 37.1094 30.5 39.7656 30.5 42.7344C30.5 48.8281 35.0312 52.5 40.6562 52.5C42.9219 52.5 45.0312 51.7969 46.75 50.625Z",
    fill: "#FDB022"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_23641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    width: 18,
    height: 42,
    fill: "#FEC84B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.5bf79cc3d73b36715fd9abace67e4193.svg";
export { ForwardRef as ReactComponent };